// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"b72de8c702da04ca","3030":"e81304dab0bc8ab7","3928":"e81304dab0bc8ab7","4825":"e81304dab0bc8ab7"}[chunkId] + ".css";
};